
import { mapState, mapActions } from "vuex";
import FileList from "./FileList.vue";

export default {
  name: "DownloadManager",

  components: { FileList },

  data() {
    return {
      downloadingFiles: [],
    };
  },

  computed: {
    ...mapState("application", ["downloads"]),
    entries() {
      return this.downloads.map((d) => ({
        ...d,
        filename: d.name,
        downloading: this.downloadingFiles.includes(d.id),
      }));
    },
  },

  methods: {
    ...mapActions({
      downloadFile: "application/downloadFile",
      setDownloads: "application/setDownloads",
    }),
    async onEntryClicked({ id, filename }) {
      this.downloadingFiles.push(id);
      await this.downloadFile({ id, filename });
      this.setDownloads();
      this.downloadingFiles = this.downloadingFiles.filter((fid) => fid !== id);
    },
  },
};
